import React from 'react';
import Input from 'react-toolbox/lib/input';
import { Button } from 'react-toolbox/lib/button';
import { connect } from 'react-redux';
import { convertGramsToLbs } from '~/utils/weight';

import { add, remove } from '~/actions/kits';

import Styles from './users.scss';

class CreatePack extends React.Component {
  static contextTypes = {
    apiClient: React.PropTypes.object.isRequired
  };
  constructor(props) {
    super(props);
    this.state = {
      edit: false,
      name: '',
      sku: '',
      toSku: '',
      origSku: '',
      count: ''
    };
  }

  componentWillReceiveProps(nextProps) {
    console.log('...', nextProps);
    if (nextProps.pack) {
      // we have a edit
      this.setState({
        edit: true,
        name: nextProps.pack.name,
        sku: nextProps.pack.sku,
        weight: convertGramsToLbs(nextProps.pack.weight),
        toSku: nextProps.pack.toSku,
        count: nextProps.pack.count,
        origSku: nextProps.pack.sku
      });
    }
  }

  create() {
    const { name, sku, toSku, count, edit, origSku, weight } = this.state;
    if (edit) {
      remove(this.props.dispatch, this.context.apiClient, origSku).then(() => {
        add(
          this.props.dispatch,
          this.context.apiClient,
          name,
          sku,
          toSku,
          weight,
          count
        )
          .then(() => {
            this.props.done();
          })
          .catch(e => {
            console.log(e);
          });
      });
    } else {
      add(
        this.props.dispatch,
        this.context.apiClient,
        name,
        sku,
        toSku,
        weight,
        count
      )
        .then(() => {
          this.props.done();
        })
        .catch(e => {
          console.log(e);
        });
    }
  }
  render() {
    const { edit } = this.state;
    return (
      <div
        className={[Styles.cardBox, Styles[this.props.transition]].join(' ')}
      >
        <div>
          <Input
            type="text"
            label="Name"
            value={this.state.name}
            onChange={e => this.setState({ name: e })}
          />
          <Input
            type="text"
            label="Kit sku"
            value={this.state.sku}
            onChange={e => this.setState({ sku: e })}
          />
          <Input
            type="text"
            label="Single sku"
            value={this.state.toSku}
            onChange={e => this.setState({ toSku: e })}
          />
          <Input
            type="text"
            label="Weight in lbs"
            value={this.state.weight}
            onChange={e => this.setState({ weight: e })}
          />
          <Input
            type="text"
            label="Quantity"
            value={this.state.count}
            onChange={e => this.setState({ count: e })}
          />
        </div>
        <div>
          <Button
            label={(edit && 'Edit') || 'Create'}
            onClick={() => {
              this.create();
            }}
          />
        </div>
      </div>
    );
  }
}
const mapStateToProps = state => ({
  users: state.getIn(['user', 'users'], {})
});

// Setting pure: false is required for react router to work
export default connect(mapStateToProps, null, null, { pure: false })(
  CreatePack
);



// WEBPACK FOOTER //
// ./app/pages/Kits/create.js